import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { PATTERN_ALPHA_NUMERIC_WITH_SPACE } from "src/app/utils/constant";
import { ItemMaintenanceService } from "../item-maintenance.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { finalize } from "rxjs/operators";
import * as _ from "lodash";

@Component({
  selector: 'esc-item-maintenance-form',
  templateUrl: './item-maintenance-form.component.html',
  styleUrls: ['./item-maintenance-form.component.scss']
})
export class ItemMaintenanceFormComponent implements OnInit {
  @Input() detail;
  @Input() mode;
  @Output() saving = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  public isDisabled;
  loading = {
    submit: false
  };
  categoryRequired;
  brandRequired;

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    public languageService: LanguageService,
    private itemMntService: ItemMaintenanceService
  ) { }

  public formGroup: FormGroup;

  ngOnInit() {
    this.initForm();
    // console.log(this.mode);
  }

  initForm() {
    this.formGroup = this.fb.group({
      code: [_.get(this.detail, "code"), [Validators.required, Validators.maxLength(20), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      description: [_.get(this.detail, "description"), [Validators.required, Validators.maxLength(100)]],

      category: [_.get(this.detail, "category"), [Validators.required]],

      brand: [_.get(this.detail, "brand"), [Validators.required]],

      price_amount: [_.get(this.detail, "price_amount"), [Validators.required, this.helper.valueGreaterThanZero,this.helper.decimalTwoPlaces]],

      status: _.get(this.detail, "is_active") == 1 ? true : false
    });

    this.toggleDisable();
  }

  toggleDisable() {
    if (!_.get(this.detail, 'id')) {
      this.formGroup.get("status").setValue(true);
      this.formGroup.get("status").disable({ emitEvent: false });
    } 
    else {
      this.formGroup.get("code").disable({ emitEvent: false });
    }
  }

  categorySelected(ev) {
    this.formGroup.get('category').setValue(ev);
    this.formGroup.get('category').markAsTouched();
  }

  brandSelected(ev) {
    this.formGroup.get('brand').setValue(ev);
    this.formGroup.get('brand').markAsTouched();
  }

  isFormValid() {
    if(this.formGroup.valid) {
      this.saveChanges()
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          this[ctrl+"Required"] = true;
        }
      }
    }
  }

  saveChanges() {
    this.loading.submit = true;
    this.formGroup.disable();
    this.isDisabled = true;

    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.detail, "id") || 0,

          code: _.toUpper(_.get(this.formGroup.get("code"), "value")),

          description: _.toUpper(_.get(this.formGroup.get("description"), "value")),

          category_id: _.toInteger(_.get(this.formGroup.get("category"), "value.id") || 1),

          brand_id: _.toInteger(_.get(this.formGroup.get("brand"), "value.id") || 1),

          price_amount: _.round((_.get(this.formGroup.get("price_amount"), "value") || 1), 2).toFixed(2),

          is_active: is_active
        }
      ]
    };
   
    this.saving.emit(true);

    this.itemMntService.insert(obj).pipe(
        finalize(() => {
          this.loading.submit = false;
          this.saving.emit(false);
          this.formGroup.enable();
          this.toggleDisable();
          this.isDisabled = false;
        })
      )
      .subscribe(
        (res: any) => {
          this.loading.submit = false;
          if (environment.showLogs) {
            console.log(res);
          }

          if (_.has(res, 'status') && _.get(res, 'status') == 0) {
            this.helper.networkErrorMessage();
            return;
          }

          if(this.helper.displayErrorMessage(res)) return;

          if (_.get(res, 'success.count') > 0) {
            //the ff needs to be an obj to display detail correctly
            obj.data[0]["category"] = _.get(this.formGroup.get("category"), "value");
            obj.data[0]["brand"] = _.get(this.formGroup.get("brand"), "value");
            obj.data[0]["price_amount"] = _.round((_.get(this.formGroup.get("price_amount"), "value") || 1), 2).toString();

            this.saving.emit(obj.data);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  disableSaveBtn() {
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if(this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          this.saveChanges();
        } else {
          this.close(false);
        }
      })
    }
    else {
      this.close(false);
    }
  }

  close(data) {
    this.closeForm.next(data);
  }
}